module.exports = __webpack_public_path__ + "files/d57a1e75678b8219f51aa2e3fdea26fa.png";